'use strict';

var Utils = require('../utils/utils');
var Navs = require('./lib/navs');
var Fixed = require('./lib/fixed');
var Scrolled = require('./lib/scrolled');

// Constructor
var MainHeader = function() {
  var self = this;

  self.config = {
    header: '.main-header',
    navs: '.main-header__navs',
    showNavs: '.main-header__show-navs',
    hideNavs: '.main-header__hide-navs',
    brandComplete: '.main-header__brand-complete',
    brandShort: '.main-header__brand-short'
  }

  self.init = function() {
    new Fixed({
      header: self.config.header
    }).init();

    new Scrolled({
      header: self.config.header,
      brandComplete: self.config.brandComplete,
      brandShort: self.config.brandShort
    }).init();

    var navsConfig = {
      navs: self.config.navs,
      show: self.config.showNavs,
      hide: self.config.hideNavs
    };

    var largeViewports = function() {
      new Navs(navsConfig).destroy();
    };

    var smallViewports = function() {
      new Navs(navsConfig).init();
    };

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = MainHeader;
